export default __webpack_public_path__ + "assets/png/baae9a6319449be3a5b1b4d3f7794e89.png";